module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log"
  }, [_vm._m(0), _vm._v(" "), (!_vm.log) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.log) ? _c('div', {
    staticClass: "log-card mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text log-info-bar"
  }, [_c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("Date:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_vm._v(_vm._s(_vm.log.date))])]), _vm._v(" "), _c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("IP:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_vm._v(_vm._s(_vm.log.ip))])]), _vm._v(" "), (_vm.user) ? _c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("User:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'user',
        params: {
          userId: _vm.user.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "material-icons user-icon"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.display))])])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand log-area"
  }, _vm._l((_vm.sortedLogMessages), function(logBucket) {
    return _c('div', {
      key: logBucket.id,
      staticClass: "log-bucket"
    }, _vm._l((logBucket.logs.map(function (x) { return JSON.parse(x); })), function(log) {
      return _c('div', {
        staticClass: "log-message",
        class: 'log-type-' + log.type
      }, [_c('span', {
        staticClass: "log-timestamp"
      }, [_vm._v("\n            " + _vm._s(_vm.formatTimestamp(log.timestamp)) + "\n          ")]), _vm._v(" "), _c('span', {
        staticClass: "log-content"
      }, [_c('span', [_vm._v(_vm._s(log.type) + ":")]), _vm._v(" "), _vm._l((log.message), function(part) {
        return _c('span', [_vm._v("\n              " + _vm._s(part) + "\n            ")])
      }), _vm._v(" "), (log.type == 'timer') ? _c('span', [_vm._v("\n              " + _vm._s(log.label) + " " + _vm._s(log.time) + "ms\n            ")]) : _vm._e(), _vm._v(" "), (log.trace) ? _c('div', [_vm._v(_vm._s(log.trace))]) : _vm._e()], 2)])
    }))
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Log Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04686d84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Log.vue
// module id = 409
// module chunks = 1